import type { FaireProductEntity } from "../../entity_types/product";

export const p_vfdxn75ppf: FaireProductEntity = {
  token: "p_vfdxn75ppf",
  type: "product",
  name: "Origami Cranes Japanese Washi Stickers JP",
  brandToken: "b_m8c3mbnsfa",
  brandName: "Urban Tokyo",
  imageUrl: "https://cdn.faire.com/fastly/067dbea33f1ec6355e3a0f2f154f1ed72853eb6372908677927fc0df3b4fcd2d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c7fa9e43497ce1f32e94125535a664a7eb0711fc3f760ddf4e90bcec73ed9d29.jpeg",
    "https://cdn.faire.com/fastly/c81b4e276fc04f1203f4a613550c87ac6c34101f91d1d052988b29c1904372a6.jpeg"
  ],
  priceDollars: 2,
  description: "Add a touch of Japan to cards, gift wrap and journals with these Origami Cranes washi stickers. Made in Japan, they make an easy add-on for gift shops and checkout counters, and a fun souvenir for fans of Japanese design.\n\nFeatures\n\n * Japanese washi stickers: a classic Japanese craft item for scrapbooks, planners, letters and gift wrap \n * Collect the series: also available in Sakura, Warlord, Origami, O-Gi Fan, Maneki Neko, Japanese Foods, Ukiyo Mt. Fuji \nSpecifications\n\n * Type: Washi stickers \n * Design: Origami Cranes \n * Inner pack: 1 \n * Case pack: 100 \n * Origin: Japan ",
  tags: [],
  msrpDollars: 4.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:02:56.289Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
